import { filter, } from 'rxjs/operators';
import { isType, } from 'tsdux';
export function ofType(actionCreators) {
    return filter((action) => isType(action, actionCreators));
}
//# sourceMappingURL=ofType.js.map